import { render, staticRenderFns } from "./LogoAvatarUploader.vue?vue&type=template&id=2ca96441&scoped=true"
import script from "./LogoAvatarUploader.vue?vue&type=script&lang=js"
export * from "./LogoAvatarUploader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca96441",
  null
  
)

export default component.exports